// extracted by mini-css-extract-plugin
var _1 = "SupportView__body--_oWvL OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE OfficeGeneral__textSizeB--Ye78Y CoreGeneral__textSizeB--joAuE OfficeGeneral__sectionContent--CCJVl";
var _2 = "SupportView__faqContainer--KHkvS";
var _3 = "SupportView__faqLabel--Uo9kH SupportView__faqText--xYmyN";
var _4 = "SupportView__faqQuestion--GMeQu SupportView__faqText--xYmyN OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _5 = "SupportView__faqQuestionContainer--rK8oQ";
var _6 = "SupportView__faqText--xYmyN";
var _7 = "SupportView__main--bvTRi";
var _8 = "SupportView__parentFaqContainer--rxBFZ";
var _9 = "SupportView__planningNewResources--MLmG8 SupportGeneral__newResources--DRbUF";
var _a = "SupportView__questionTextShort--f8bVO";
var _b = "SupportView__tabContainer--ONWKJ";
var _c = "SupportView__tabTitle--BkyJI";
var _d = "SupportView__teacherFaqContainer--f1BwL SupportView__faqContainer--KHkvS";
export { _1 as "body", _2 as "faqContainer", _3 as "faqLabel", _4 as "faqQuestion", _5 as "faqQuestionContainer", _6 as "faqText", _7 as "main", _8 as "parentFaqContainer", _9 as "planningNewResources", _a as "questionTextShort", _b as "tabContainer", _c as "tabTitle", _d as "teacherFaqContainer" }
